// NPM imports

import moment from 'moment';

// Project imports

import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { luftGet, luftPost, luftPut, luftDelete } from '../shared/http';

// actions

const REQUEST_LUFT_USERS = 'luft/admin-luft-users/REQUEST_LUFT_USERS';
const REQUEST_LUFT_USERS_SUCCESS =
  'luft/admin-luft-users/REQUEST_LUFT_USERS_SUCCESS';
const REQUEST_LUFT_USERS_FAILURE =
  'luft/admin-luft-users/REQUEST_LUFT_USERS_FAILURE';

const ADD_LUFT_USER = 'luft/admin-luft-users/ADD_LUFT_USER';
const ADD_LUFT_USER_SUCCESS = 'luft/admin-luft-users/ADD_LUFT_USER_SUCCESS';
const ADD_LUFT_USER_FAILURE = 'luft/admin-luft-users/ADD_LUFT_USER_FAILURE';
const ADD_LUFT_USER_CLEAR = 'luft/admin-luft-users/ADD_LUFT_USER_CLEAR';

const UPDATE_LUFT_USER = 'luft/admin-luft-users/UPDATE_LUFT_USER';
const UPDATE_LUFT_USER_SUCCESS =
  'luft/admin-luft-users/UPDATE_LUFT_USER_SUCCESS';
const UPDATE_LUFT_USER_FAILURE =
  'luft/admin-luft-users/UPDATE_LUFT_USER_FAILURE';
const UPDATE_LUFT_USER_CLEAR = 'luft/admin-luft-users/UPDATE_LUFT_USER_CLEAR';

const REMOVE_LUFT_USER = 'luft/admin-luft-users/REMOVE_LUFT_USER';
const REMOVE_LUFT_USER_SUCCESS =
  'luft/admin-luft-users/REMOVE_LUFT_USER_SUCCESS';
const REMOVE_LUFT_USER_FAILURE =
  'luft/admin-luft-users/REMOVE_LUFT_USER_FAILURE';
const REMOVE_LUFT_USER_CLEAR = 'luft/admin-luft-users/REMOVE_LUFT_USER_CLEAR';

// reducer

const initialState = {
  luftUsers: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  addLuftUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
  updateLuftUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
  removeLuftUser: {
    isFetching: false,
    error: '',
    requested: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_LUFT_USERS: {
      return {
        ...state,
        luftUsers: {
          ...state.luftUsers,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case REQUEST_LUFT_USERS_SUCCESS: {
      return {
        ...state,
        luftUsers: {
          ...state.luftUsers,
          isFetching: false,
          error: '',
          data: action.data,
        },
      };
    }

    case REQUEST_LUFT_USERS_FAILURE:
      return {
        ...state,
        luftUsers: {
          ...state.luftUsers,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_LUFT_USER: {
      return {
        ...state,
        addLuftUser: {
          ...state.addLuftUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case ADD_LUFT_USER_SUCCESS: {
      return {
        ...state,
        addLuftUser: {
          ...state.addLuftUser,
          isFetching: false,
          error: '',
        },
      };
    }

    case ADD_LUFT_USER_FAILURE:
      return {
        ...state,
        addLuftUser: {
          ...state.addLuftUser,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_LUFT_USER_CLEAR:
      return {
        ...state,
        addLuftUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_LUFT_USER: {
      return {
        ...state,
        updateLuftUser: {
          ...state.updateLuftUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case UPDATE_LUFT_USER_SUCCESS: {
      return {
        ...state,
        updateLuftUser: {
          ...state.updateLuftUser,
          isFetching: false,
          error: '',
        },
      };
    }

    case UPDATE_LUFT_USER_FAILURE:
      return {
        ...state,
        updateLuftUser: {
          ...state.updateLuftUser,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_LUFT_USER_CLEAR:
      return {
        ...state,
        updateLuftUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case REMOVE_LUFT_USER: {
      return {
        ...state,
        removeLuftUser: {
          ...state.removeLuftUser,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case REMOVE_LUFT_USER_SUCCESS: {
      return {
        ...state,
        removeLuftUser: {
          ...state.removeLuftUser,
          isFetching: false,
          error: '',
        },
        luftUsers: {
          ...state.luftUsers,
          data: state.luftUsers.data.filter(el => el.id !== action.data.userId),
        },
      };
    }

    case REMOVE_LUFT_USER_FAILURE:
      return {
        ...state,
        removeLuftUser: {
          ...state.removeLuftUser,
          isFetching: false,
          error: action.error,
        },
      };

    case REMOVE_LUFT_USER_CLEAR:
      return {
        ...state,
        removeLuftUser: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators
// list
function requestLuftUsers() {
  return { type: REQUEST_LUFT_USERS };
}

function requestLuftUsersSuccess(data) {
  return {
    type: REQUEST_LUFT_USERS_SUCCESS,
    data,
  };
}

function requestLuftUsersFailure(error) {
  return {
    type: REQUEST_LUFT_USERS_FAILURE,
    error,
  };
}

// add
function addLuftUser() {
  return { type: ADD_LUFT_USER };
}

function addLuftUserSuccess(data) {
  return {
    type: ADD_LUFT_USER_SUCCESS,
    data,
  };
}

function addLuftUserFailure(error) {
  return {
    type: ADD_LUFT_USER_FAILURE,
    error,
  };
}

export function addLuftUserClear() {
  return { type: ADD_LUFT_USER_CLEAR };
}

// update
function updateLuftUser() {
  return { type: UPDATE_LUFT_USER };
}

function updateLuftUserSuccess(data) {
  return {
    type: UPDATE_LUFT_USER_SUCCESS,
    data,
  };
}

function updateLuftUserFailure(error) {
  return {
    type: UPDATE_LUFT_USER_FAILURE,
    error,
  };
}

export function updateLuftUserClear() {
  return { type: UPDATE_LUFT_USER_CLEAR };
}

// remove
function removeLuftUser() {
  return { type: REMOVE_LUFT_USER };
}

function removeLuftUserSuccess(data) {
  return {
    type: REMOVE_LUFT_USER_SUCCESS,
    data,
  };
}

function removeLuftUserFailure(error) {
  return {
    type: REMOVE_LUFT_USER_FAILURE,
    error,
  };
}

export function removeLuftUserClear() {
  return { type: REMOVE_LUFT_USER_CLEAR };
}

// thunk action creators
export function fetchLuftUsers(query) {
  return function (dispatch) {
    (async () => {
      dispatch(requestLuftUsers());

      const params = query ? { query } : null;

      try {
        const response = await luftGet('/LuftUser', params);
        dispatch(requestLuftUsersSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          requestLuftUsersFailure(error.message),
        );
      }
    })();
  };
}

export function fetchAddLuftUser(name, email, subsidiaries, roles) {
  return function (dispatch) {
    return (async () => {
      dispatch(addLuftUser());

      const requestBody = {
        name,
        email,
        subsidiaries,
        roles,
      };

      try {
        const response = await luftPost('/LuftUser', requestBody);
        dispatch(addLuftUserSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          addLuftUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchUpdateLuftUser(id, name, email, subsidiaries, roles) {
  return function (dispatch) {
    return (async () => {
      dispatch(updateLuftUser());

      const requestBody = {
        id,
        name,
        email,
        subsidiaries,
        roles,
      };

      try {
        const response = await luftPut('/LuftUser', requestBody);
        dispatch(updateLuftUserSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          updateLuftUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchRemoveLuftUser(userId) {
  return function (dispatch) {
    return (async () => {
      dispatch(removeLuftUser());

      const params = { userId };

      try {
        await luftDelete('/LuftUser', params);
        dispatch(removeLuftUserSuccess(params));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          removeLuftUserFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}
